import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { mapToCalendar } from 'utils/mappers';
import 'moment/locale/en-gb';

const localizer = momentLocalizer(moment);

class CalendarSchedule extends Component {
    componentDidMount() {
        this.setMomentLocale();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isHighTide !== this.props.isHightide || prevProps.isInspired !== this.props.isInspired) {
            this.setMomentLocale();
        }
    }
      
    setMomentLocale = () => {
        // "en" for MON to SUN, "en-gb" for SUN to SAT
        moment.locale(this.props.isHightide || this.props.isInspired ? "en" : "en-gb");
    }

    EventPropGetter = (event) => {
        let color = event.color == "" || event.color == null ? '#893086' : event.color;
        // let fontColor = this.invertColor(color);
        let model = {
            className: "",
            style: {
                backgroundColor: color + "B2",
                // color: fontColor,
            }
        }
        return model;
    }

    invertColor = (hex) => {
        if (hex.indexOf('#') === 0) {
            hex = hex.slice(1);
        }
        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if (hex.length !== 6) {
            throw new Error('Invalid HEX color.');
        }
        var r = parseInt(hex.slice(0, 2), 16),
            g = parseInt(hex.slice(2, 4), 16),
            b = parseInt(hex.slice(4, 6), 16);

        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }

    render() {
        return (
            <div className="calendar_schedule">
                <Calendar
                    selectable
                    culture="en-GB"
                    localizer={localizer}
                    events={mapToCalendar(this.props.schedules)}
                    eventPropGetter={this.EventPropGetter}
                    views={['month', 'week', 'day']}
                    showMultiDayTimes
                    startAccessor="start"
                    endAccessor="end"
                    onSelectEvent={(event) => this.props.populateDialog(event)}
                    onSelectSlot={(e) => this.props.handleAddDialog ? this.props.handleAddDialog(e, e.start) : ""}
                    onNavigate={(date, view) => this.props.onNavigate ? this.props.onNavigate(date, view) : ""}
                    onView={(view) => {
                        this.props.onView ? this.props.onView(view) : () => { }
                    }}
                    popup
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isHightide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

export default connect(mapStateToProps)(CalendarSchedule);